/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemSettingDto model module.
 * @module model/SystemSettingDto
 * @version v1.0.0
 */
class SystemSettingDto {
    /**
     * Constructs a new <code>SystemSettingDto</code>.
     * @alias module:model/SystemSettingDto
     */
    constructor() { 
        
        SystemSettingDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemSettingDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemSettingDto} obj Optional instance to populate.
     * @return {module:model/SystemSettingDto} The populated <code>SystemSettingDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemSettingDto();

            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], Object);
            }
        }
        return obj;
    }


}

/**
 * description
 * @member {String} description
 */
SystemSettingDto.prototype['description'] = undefined;

/**
 * key
 * @member {String} key
 */
SystemSettingDto.prototype['key'] = undefined;

/**
 * value
 * @member {Object} value
 */
SystemSettingDto.prototype['value'] = undefined;






export default SystemSettingDto;

